import { defineMessages, useIntl } from "react-intl";

import {
  queryClient,
  MutationActions,
  QueryKeys,
  useEntityMutation,
} from "@/api/core";
import { useApi } from "@/hooks";
import { statusSchema } from "@/schemas";
import toast from "@/toast";

import { updateStatusCache } from "../utils";

const messages = defineMessages({
  muteSuccess: {
    id: "status.mute.success",
    defaultMessage: "You have successfully muted this Truth.",
  },
  deletedTruth: {
    id: "status.error.deletedTruth",
    defaultMessage: "This Truth has been deleted and is no longer available.",
  },
});

interface Variables {
  id: string;
}

function useMuteStatus() {
  const api = useApi();
  const intl = useIntl();

  return useEntityMutation({
    globalQueryKey: QueryKeys.statuses.global,
    idAttributeFromVariables: "id",
    action: MutationActions.UPDATE,
    schema: statusSchema,
    mutationFn: (variables: Variables) =>
      api.post(`/api/v1/statuses/${variables.id}/mute`),
    onMutate(variables) {
      const [prevStatus] = updateStatusCache(variables.id, () => ({
        muted: true,
      }));

      return { prevStatus };
    },
    onSuccess() {
      toast.success(intl.formatMessage(messages.muteSuccess));
    },
    onError(error, variables, context) {
      if (error.response?.status === 404) {
        toast.error(intl.formatMessage(messages.deletedTruth));
      }
      if (context) {
        queryClient.setQueryData(
          QueryKeys.statuses.detail(variables.id),
          context.prevStatus,
        );
      }
    },
  });
}

export { useMuteStatus };
